import React from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog';

interface ApprovalDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

const ApprovalDialog: React.FC<ApprovalDialogProps> = ({
    isOpen,
    onClose
}) => {
    const navigate = useNavigate();

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            width="w-[400px]"
            id="approval-dialog"
        >
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center">
                        <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                </div>
                <h2 className="text-2xl font-medium mb-4">Completed !</h2>

                <p className="text-gray-600 mb-6">
                    The jobsite has been successfully marked as completed. Thank you for your efforts!
                </p>
                <button
                    onClick={() => navigate('/jobsite-management')}
                    className="btn-primary"
                    id="back-to-jobsite-button"
                >
                    Back to Jobsite Management
                </button>
            </div>
        </Dialog>
    );
};

export default ApprovalDialog; 